/* eslint-disable @next/next/no-img-element */
import HomeStory from "components/cong-dong/home-story";
import ImageStore from "components/cong-dong/imageStore";
import { useRouter } from "next/router";
import Link from 'next/link';
import {isEmpty} from 'lodash';
import Product from "components/shop/product";
import LuuTruSanPham from "components/tai-khoan/mua-sam/so-luu-tru-san-pham";

export default function HoSo({ pins, wishlist, rootPath , isPro = false}) {
    if(isEmpty(pins)) return <></>;
    const router = useRouter();
    const baiViet = pins.articles?.data || [];
    const khoAnh = pins.photos?.data || [];
    const thaoLuan = pins.thread?.data || [];
    const review = pins.reviews?.data || [];
    const sanpham = wishlist.items;

    let currentTab = router.query?.bookmark || 'chuyen-nha';
    if (!router.query?.bookmark) {
        if(!isEmpty(baiViet)) currentTab = 'chuyen-nha';
        if(!isEmpty(khoAnh)) currentTab = 'kho-anh';
        if(!isEmpty(thaoLuan)) currentTab = 'review';
        if(!isEmpty(review)) currentTab = 'thao-luan';
        if(!isEmpty(sanpham)) currentTab = 'san-pham';
    }

    const getActive = (menu) => {
        return (currentTab == menu ? "active" : "");
    };

    const tabContent = {
        'chuyen-nha': (<HomeStory item={baiViet} slug="chuyen-nha" forceChuyenNha={true}></HomeStory>),
        'kho-anh': (<ImageStore item={khoAnh} ></ImageStore>),
        'review': (<HomeStory item={review} slug="review"></HomeStory>),
        'thao-luan': (<HomeStory item={thaoLuan} slug="thao-luan"></HomeStory>),
        'san-pham': (<LuuTruSanPham></LuuTruSanPham>),
    };

    return (
        <>
            {!(isEmpty(baiViet) && isEmpty(khoAnh) && isEmpty(review) && isEmpty(thaoLuan) && isEmpty(sanpham)) && <>
                <div className="navSetting">
                    <div className="tab-content">
                        <ul className="navHistory text-left">
                            {!isEmpty(baiViet) && <li>
                                <Link href={`${rootPath}&bookmark=chuyen-nha`}>
                                    <a className={getActive("chuyen-nha")}>Chuyện nhà <span>{baiViet?.length}</span>
                                    </a>
                                </Link>
                            </li>}
                            {!isEmpty(khoAnh) && <li>
                                <Link href={`${rootPath}&bookmark=kho-anh`}>
                                    <a className={getActive("kho-anh")}>Kho ảnh  <span>{khoAnh?.length}</span>
                                    </a>
                                </Link>
                            </li>}
                            {!isEmpty(review) && <li>
                                <Link href={`${rootPath}&bookmark=review`}>
                                    <a className={getActive("review")}>Review  <span>{review?.length}</span>
                                    </a>
                                </Link>
                            </li>}
                            {!isEmpty(thaoLuan) && <li>
                                <Link href={`${rootPath}&bookmark=thao-luan`}>
                                    <a className={getActive("thao-luan")}>Thảo luận  <span>{thaoLuan?.length}</span>
                                    </a>
                                </Link>
                            </li>}
                            {!isEmpty(sanpham) && <li>
                                <Link href={`${rootPath}&bookmark=san-pham`}>
                                    <a className={getActive("san-pham")}>Sản phẩm  <span>{sanpham?.length}</span>
                                    </a>
                                </Link>
                            </li>}
                        </ul>
                    </div>
                </div>
                <div className={"lstView-pro" + (isPro ? " luu-tru-pro" : "")}>
                    {tabContent[currentTab]}
                </div>
            </>
            }

            {
                isEmpty(baiViet) && isEmpty(khoAnh) && isEmpty(review) && isEmpty(thaoLuan) && isEmpty(sanpham) && <div className="empty-data">
                    <div className="voucher-none">
                        <div className="thumb"><img src="/images/icon-no-data.svg" alt="" /></div>
                        <p className="text">Dữ liệu trống</p>
                    </div>
                </div>
            }
        </>
    );
}